import image1 from "./asset/about_me_background.png";
import image2 from "./asset/about_me_menu.svg";
import image3 from "./asset/aboutMeIcon.svg";
import image4 from "./asset/aboutMeIcon_grey.svg";
import image5 from "./asset/back_to_menu.svg";
import image6 from "./asset/background_image_4.svg"
import image7 from "./asset/background_texture.jpg"
import image8 from "./asset/bookcover.svg"
import image9 from "./asset/bottom_links.png"
import image10 from "./asset/bottom_links.svg"
import image11 from "./asset/bottom_links_color.svg"
import image12 from "./asset/camera.svg"
import image13 from "./asset/camera_ani_1.svg"
import image14 from "./asset/camera_ani_10.svg"
import image15 from "./asset/camera_ani_11.svg"
import image16 from "./asset/camera_ani_12.svg"
import image17 from "./asset/camera_ani_13.svg"
import image18 from "./asset/camera_ani_14.svg"
import image19 from "./asset/camera_ani_15.svg"
import image20 from "./asset/camera_ani_16.svg"
import image21 from "./asset/camera_ani_17.svg"
import image22 from "./asset/camera_ani_18.svg"
import image23 from "./asset/camera_ani_19.svg"
import image24 from "./asset/camera_ani_2.svg"
import image25 from "./asset/camera_ani_20.svg"
import image26 from "./asset/camera_ani_21.svg"
import image27 from "./asset/camera_ani_22.svg"
import image28 from "./asset/camera_ani_23.svg"
import image29 from "./asset/camera_ani_24.svg"
import image30 from "./asset/camera_ani_25.svg"
import image31 from "./asset/camera_ani_26.svg"
import image32 from "./asset/camera_ani_27.svg"
import image33 from "./asset/camera_ani_3.svg"
import image34 from "./asset/camera_ani_4.svg"
import image35 from "./asset/camera_ani_5.svg"
import image36 from "./asset/camera_ani_6.svg"
import image37 from "./asset/camera_ani_7.svg"
import image38 from "./asset/camera_ani_8.svg"
import image39 from "./asset/camera_ani_9.svg"
import image40 from "./asset/camera_empty.svg"
import image41 from "./asset/circle.svg"
import image42 from "./asset/click_the_category.svg"
import image43 from "./asset/click_the_image_to_watch.png"
import image44 from "./asset/click_the_image_to_watch.svg"
import image45 from "./asset/clickMenu.svg"
import image46 from "./asset/coding.svg"
import image47 from "./asset/coding_1.svg"
import image48 from "./asset/coding_2.svg"
import image49 from "./asset/coding_3.svg"
import image50 from "./asset/coding_4.png"
import image51 from "./asset/coding_4.svg"
import image52 from "./asset/coding_5.png"
import image53 from "./asset/coding_6.svg"
import image54 from "./asset/coding_empty.svg"
import image55 from "./asset/coding_text.svg"
import image56 from "./asset/commercial_1.png"
import image57 from "./asset/commercial_2.png"
import image58 from "./asset/commercial_3.svg"
import image59 from "./asset/commercial_4.svg"
import image60 from "./asset/commercial_5.png"
import image61 from "./asset/constellation1.svg"
import image62 from "./asset/constellation2.svg"
import image63 from "./asset/contactIcon.svg"
import image64 from "./asset/contactIcon_grey.svg"
import image65 from "./asset/cursor.png"
import image66 from "./asset/design_1_1.png"
import image67 from "./asset/design_1_2.png"
import image68 from "./asset/design_1_3.png"
import image69 from "./asset/design_1_4.png"
import image70 from "./asset/design_1_5.png"
import image71 from "./asset/design_1_6.png"
import image72 from "./asset/design_1_7.png"
import image73 from "./asset/design_1_8.png"
import image74 from "./asset/design_2_1.png"
import image75 from "./asset/design_2_2.png"
import image76 from "./asset/design_2_3.svg"
import image77 from "./asset/design_2_4.png"
import image78 from "./asset/design_3_1.png"
import image79 from "./asset/design_3_2.png"
import image80 from "./asset/design_3_3.png"
import image81 from "./asset/design_3_4.png"
import image82 from "./asset/design_3_5.png"
import image83 from "./asset/design_3_6.png"
import image84 from "./asset/design_4_1.png"
import image85 from "./asset/design_4_2.png"
import image86 from "./asset/design_4_3.png"
import image87 from "./asset/design_4_4.png"
import image88 from "./asset/design_4_5.png"
import image89 from "./asset/design_5_1.png"
import image90 from "./asset/design_5_2.png"
import image91 from "./asset/design_5_3.png"
import image92 from "./asset/design_5_4.png"
import image93 from "./asset/design_text.svg"
import image94 from "./asset/drag_and_drop.svg"
import image95 from "./asset/drag_or_click.svg"
import image96 from "./asset/drawing_text.svg"
import image97 from "./asset/english_below.svg"
import image98 from "./asset/grab.png"
import image99 from "./asset/graphic.svg"
import image100 from "./asset/graphic_empty.svg"
import image101 from "./asset/image_selected.svg"
import image102 from "./asset/interview_1.svg"
import image103 from "./asset/interview_2.png"
import image104 from "./asset/interview_3.svg"
import image105 from "./asset/interview_4.png"
import image106 from "./asset/left_aboutMe.png"
import image107 from "./asset/left_aboutMe_color.png"
import image108 from "./asset/left_aboutMe_color.svg"
import image109 from "./asset/linksIcon.svg"
import image110 from "./asset/linksIcon_grey.svg"
import image111 from "./asset/logos.svg"
import image112 from "./asset/main-projects.svg"
import image113 from "./asset/music_video_1.png"
import image114 from "./asset/music_video_2.png"
import image115 from "./asset/music_video_3.svg"
import image116 from "./asset/music_video_3-1.png"
import image117 from "./asset/music_video_4.png"
import image118 from "./asset/music_video_5.svg"
import image119 from "./asset/music_video_6.svg"
import image120 from "./asset/music_video_7.png"
import image121 from "./asset/mySelf.jpeg"
import image122 from "./asset/mySelf.png"
import image123 from "./asset/news_1.png"
import image124 from "./asset/news_2.png"
import image125 from "./asset/news_3.png"
import image126 from "./asset/news_4.png"
import image127 from "./asset/news_5.png"
import image128 from "./asset/news_6.png"
import image129 from "./asset/news_7.svg"
import image130 from "./asset/pc.svg"
import image131 from "./asset/photo_text.svg"
import image132 from "./asset/pink_dot.svg"
import image133 from "./asset/pointer.png"
import image134 from "./asset/poster.svg"
import image135 from "./asset/poster1.png"
import image136 from "./asset/poster2.png"
import image137 from "./asset/poster3.png"
import image138 from "./asset/poster4.png"
import image139 from "./asset/promotion.svg"
import image140 from "./asset/purple_dot.svg"
import image141 from "./asset/reading_glasses.png"
import image142 from "./asset/right_works.png"
import image143 from "./asset/right_works_color.png"
import image144 from "./asset/right_works_color.svg"
import image145 from "./asset/satellite.svg"
import image146 from "./asset/saturn_1.svg"
import image147 from "./asset/series-works.svg"
import image148 from "./asset/shadow.png"
import image149 from "./asset/shadow_bottom_links.svg"
import image150 from "./asset/shadow_left_aboutMe.png"
import image151 from "./asset/shadow_left_aboutMe.svg"
import image152 from "./asset/shadow_right_works.png"
import image153 from "./asset/shadow_right_works.svg"
import image154 from "./asset/shadow_top_contact.svg"
import image155 from "./asset/short_film_1.png"
import image156 from "./asset/short_film_2.svg"
import image157 from "./asset/short_film_3.png"
import image158 from "./asset/short_film_4.png"
import image159 from "./asset/skyblue_dot.svg"
import image160 from "./asset/smile.svg"
import image161 from "./asset/star1.svg"
import image162 from "./asset/thisIsMe.svg"
import image163 from "./asset/thisWebsite.svg"
import image164 from "./asset/top_contact.png"
import image165 from "./asset/top_contact_color.svg"
import image166 from "./asset/toy-projects.svg"
import image167 from "./asset/travel.svg"
import image168 from "./asset/travel_empty.svg"
import image169 from "./asset/travel_video_1.svg"
import image170 from "./asset/travel_video_2.png"
import image171 from "./asset/travel_video_3.svg"
import image172 from "./asset/travel_video_4.svg"
import image173 from "./asset/usb.svg"
import image174 from "./asset/usb_hub.svg"
import image175 from "./asset/video_production_0.svg"
import image176 from "./asset/video_production_1.svg"
import image177 from "./asset/video_production_3.svg"
import image178 from "./asset/video_production_4.svg"
import image179 from "./asset/video_production_5.svg"
import image180 from "./asset/video_select_background_image.png"
import image181 from "./asset/video_text.svg"
import image182 from "./asset/visit.svg"
import image183 from "./asset/web_development_0.svg"
import image184 from "./asset/web_development_1.svg"
import image185 from "./asset/web_development_10.svg"
import image186 from "./asset/web_development_11.svg"
import image187 from "./asset/web_development_12.svg"
import image188 from "./asset/web_development_13.svg"
import image189 from "./asset/web_development_14.svg"
import image190 from "./asset/web_development_15.svg"
import image191 from "./asset/web_development_2.svg"
import image192 from "./asset/web_development_3.svg"
import image193 from "./asset/web_development_4.svg"
import image194 from "./asset/web_development_5.svg"
import image195 from "./asset/web_development_6.svg"
import image196 from "./asset/web_development_7.svg"
import image197 from "./asset/web_development_8.svg"
import image198 from "./asset/web_development_9.svg"
import image199 from "./asset/workInProgress.svg"
import image200 from "./asset/worksIcon.svg"
import image201 from "./asset/worksIcon_grey.svg"
import image202 from "./asset/x.svg"
import image203 from "./asset/youtube.png"
import image204 from "./asset/coding_7.png"

import image205 from "./asset/1stExhibition/ph1.png";
import image206 from "./asset/1stExhibition/ph2.png";
import image207 from "./asset/1stExhibition/ph3.png";
import image208 from "./asset/1stExhibition/ph4.png";
import image209 from "./asset/1stExhibition/ph5.png";
import image210 from "./asset/1stExhibition/ph6.png";
import image211 from "./asset/1stExhibition/ph7.png";
import image212 from "./asset/1stExhibition/ph8.png";
import image213 from "./asset/1stExhibition/ph9.png";
import image214 from "./asset/1stExhibition/ph10.png";
import image215 from "./asset/1stExhibition/ph11.png";
import image216 from "./asset/1stExhibition/ph12.png";
import image217 from "./asset/1stExhibition/ph13.png";
import image218 from "./asset/1stExhibition/ph14.png";
import image219 from "./asset/1stExhibition/ph15.png";

import image220 from "./asset/2ndExhibition/ph1.png";
import image221 from "./asset/2ndExhibition/ph2.png";
import image222 from "./asset/2ndExhibition/ph3.png";
import image223 from "./asset/2ndExhibition/ph4.png";
import image224 from "./asset/2ndExhibition/ph5.png";
import image225 from "./asset/2ndExhibition/ph6.png";
import image226 from "./asset/2ndExhibition/ph7.png";
import image227 from "./asset/2ndExhibition/ph8.png";
import image228 from "./asset/2ndExhibition/ph9.png";
import image229 from "./asset/2ndExhibition/ph10.png";
import image230 from "./asset/2ndExhibition/ph11.png";

import image231 from "./asset/3rdExhibition/ph1.png";
import image232 from "./asset/3rdExhibition/ph2.png";

import image233 from "./asset/4thExhibition/ph1.png";
import image234 from "./asset/4thExhibition/ph2.png";
import image235 from "./asset/4thExhibition/ph3.png";
import image236 from "./asset/4thExhibition/ph4.png";
import image237 from "./asset/4thExhibition/ph5.png";
import image238 from "./asset/4thExhibition/ph6.png";
import image239 from "./asset/4thExhibition/ph7.png";

const preLoadImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27,
    image28,
    image29,
    image30,
    image31,
    image32,
    image33,
    image34,
    image35,
    image36,
    image37,
    image38,
    image39,
    image40,
    image41,
    image42,
    image43,
    image44,
    image45,
    image46,
    image47,
    image48,
    image49,
    image50,
    image51,
    image52,
    image53,
    image54,
    image55,
    image56,
    image57,
    image58,
    image59,
    image60,
    image61,
    image62,
    image63,
    image64,
    image65,
    image66,
    image67,
    image68,
    image69,
    image70,
    image71,
    image72,
    image73,
    image74,
    image75,
    image76,
    image77,
    image78,
    image79,
    image80,
    image81,
    image82,
    image83,
    image84,
    image85,
    image86,
    image87,
    image88,
    image89,
    image90,
    image91,
    image92,
    image93,
    image94,
    image95,
    image96,
    image97,
    image98,
    image99,
    image100,
    image101,
    image102,
    image103,
    image104,
    image105,
    image106,
    image107,
    image108,
    image109,
    image110,
    image111,
    image112,
    image113,
    image114,
    image115,
    image116,
    image117,
    image118,
    image119,
    image120,
    image121,
    image122,
    image123,
    image124,
    image125,
    image126,
    image127,
    image128,
    image129,
    image130,
    image131,
    image132,
    image133,
    image134,
    image135,
    image136,
    image137,
    image138,
    image139,
    image140,
    image141,
    image142,
    image143,
    image144,
    image145,
    image146,
    image147,
    image148,
    image149,
    image150,
    image151,
    image152,
    image153,
    image154,
    image155,
    image156,
    image157,
    image158,
    image159,
    image160,
    image161,
    image162,
    image163,
    image164,
    image165,
    image166,
    image167,
    image168,
    image169,
    image170,
    image171,
    image172,
    image173,
    image174,
    image175,
    image176,
    image177,
    image178,
    image179,
    image180,
    image181,
    image182,
    image183,
    image184,
    image185,
    image186,
    image187,
    image188,
    image189,
    image190,
    image191,
    image192,
    image193,
    image194,
    image195,
    image196,
    image197,
    image198,
    image199,
    image200,
    image201,
    image202,
    image203,
    image204,
    image205,
    image206,
    image207,
    image208,
    image209,
    image210,
    image211,
    image212,
    image213,
    image214,
    image215,
    image216,
    image217,
    image218,
    image219,
    image220,
    image221,
    image222,
    image223,
    image224,
    image225,
    image226,
    image227,
    image228,
    image229,
    image230,
    image231,
    image232,
    image233,
    image234,
    image235,
    image236,
    image237,
    image238,
    image239
]

export default preLoadImages;